import csharp from './../skills/csharp.png'
import css3 from './../skills/css3.png'
import express from './../skills/expressjs.png'
import figma from './../skills/figma.png'
import git from './../skills/git.png'
import github from './../skills/github.png'
import html5 from './../skills/html5.png'
import java from './../skills/java.png'
import javascript from './../skills/javascript.png'
import jira from './../skills/jira.png'
import mongodb from './../skills/mongodb.png'
import mysql from './../skills/mysql.png'
import nodejs from './../skills/nodejs.png'
import npm from './../skills/npm.png'
import photoshop from './../skills/photoshop.png'
import php from './../skills/php.png'
import phpmyadmin from './../skills/phpmyadmin.png'
import react from './../skills/react.png'
import wordpress from './../skills/wordpress.png'

const Icons = [
    { name: "csharp" , src: csharp },
    { name: "css3" , src: css3 },
    { name: "express" , src: express },
    { name: "figma" , src: figma },
    { name: "git", src: git },
    { name: "github", src: github },
    { name: "html5", src: html5 },
    { name: "java", src: java },
    { name: "javascript", src: javascript },
    { name: "jira", src: jira },
    { name: "mongodb", src: mongodb },
    { name: "mysql", src: mysql },
    { name: "nodejs", src: nodejs },
    { name: "npm", src: npm },
    { name: "photoshop", src: photoshop },
    { name: "php", src: php },
    { name: "phpmyadmin", src: phpmyadmin },
    { name: "react", src: react },
    { name: "wordpress", src: wordpress }
];


export default Icons ;

